import { BookV1 } from '@ilteducation/content-registry-types';
import axios, { AxiosResponse } from 'axios';
import { term } from 'lucene';
import { sleep } from '@/foundations/helpers/sleep';
import customProvider from '@/data-provider/customProvider';
import { getEndpointUrl } from '@/config/ConfigProvider';

const bookListUrl = process.env.VUE_APP_BOOKS_API_URL_LIST;

export const getDuplicateBooks = async (book: BookV1): Promise<BookV1[]> => {
  const url = `${bookListUrl}`;

  if (!book.originalTitle) {
    return [];
  }

  const escapedOriginalTitle = term.escape(book.originalTitle);

  const limit = 100;
  const response = await axios.request({
    url,
    params: {
      filter: `originalTitle:${escapedOriginalTitle}`,
      'pagination[size]': limit,
    },
    method: 'GET',
  });

  const booksByOriginalTitle = response.data.data as BookV1[];

  return booksByOriginalTitle.filter((b) => b.id !== book.id);
};

export const copyAudioFiles = async (sourceBook: BookV1, targetBook: BookV1, languageCode: string): Promise<void> => {
  const url = `${getEndpointUrl('books')}copyAudioFiles`;

  await axios.request({
    url,
    method: 'POST',
    data: {
      sourceContentId: sourceBook.id,
      targetContentId: targetBook.id,
      languageCode,
    },
  });
};

export const waitForBookToHaveAudio = async (bookId: string, languageCode: string): Promise<void> => {
  const maxRetries = 60;
  const retryIntervalMs = 10 * 1000;

  let retries = 1;

  await sleep(retryIntervalMs);

  while (retries <= maxRetries) {
    // eslint-disable-next-line no-await-in-loop
    const bookResponse = (await customProvider().getOne('books', { id: bookId })) as AxiosResponse<BookV1>;
    const book = bookResponse.data;

    if (book.languages.audio?.includes(languageCode) && book.state === 'published') {
      break;
    } else {
      retries += 1;
      // eslint-disable-next-line no-await-in-loop
      await sleep(retryIntervalMs);
    }
  }

  if (retries > maxRetries) {
    throw new Error(`Book did not have audio files after waiting. Retried ${retries} times`);
  }
};
